// Redirects after submit

document.addEventListener( 'wpcf7mailsent', function( event ) {
  location = wpdata.redirectDefaultConfirmation;
}, false );
